import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { AlSection, AlEvalRow } from 'PatientCareCenter/Note/AL';


class AlEval extends React.Component {

    add() {
        this.props.addAlRow(this.props.noteId, 'MLEVAL', 'XLEV', 'XLEVNO', 'XLEVXLNO', this.props.xlno, 'NEW_XLEVNO', false, this.props.isSpeech);
    }

    componentDidUpdate() {
        if (this.props.evals.length === 0 && this.props.time !== null) {
            this.props.clearFields(this.props.noteId, 'MLEXLOG', 'XLNO', this.props.xlno, ['XLTIMEEVAL', 'XLTIMEEVALASSIST']);
        }
    }


    render() {
        return (
            <AlSection
                id='al_evals'
                name='Evals'
                subLabel={'FOTO Complexity: ' + this.props.fotoComplexity}
                timeField='XLTIMEEVAL'
                timeRequired={this.props.evals.length > 0 && this.props.time === null ? true : false}
                timeVisible={this.props.evals.length > 0 ? true : false}
                onAdd={() => this.add()}
                addVisible={this.props.evals.length > 0 ? false : true}
                skipTherapistAssistantTimeCalulation={true}
            >
                {Object.keys(this.props.evals)
                    .map(key => {
                        const result = this.props.evals[key];
                        return (
                            <AlEvalRow key={result.XLEVNO} id={result.XLEVNO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

    let pocs = Object.keys(state.entities.notes.EVALCODES)
        .filter(key => {
            return (
                (
                    (noteType === 1 && state.entities.notes.EVALCODES[key].RTEVNO === pk) ||
                    (noteType !== 1 && state.entities.notes.EVALCODES[key].RTNTNO === pk)
                ) &&
                state.entities.notes.EVALCODES[key].RTCODE.includes('POC')
            )
        })
        .map(key => state.entities.notes.EVALCODES[key].RTNO);

    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled;

    return {
        noteId: noteId,
        xlno: xlno,
        time: state.entities.notes.MLEXLOG[xlno].XLTIMEEVAL,
        fotoComplexity: state.entities.admissions[epno].fotoComplexity !== null ? state.entities.admissions[epno].fotoComplexity : 'TBD',
        evals: Object.keys(state.entities.notes.MLEVAL)
            .filter(key => {
                return (state.entities.notes.MLEVAL[key].XLEVXLNO === xlno &&
                    !pocs.includes(state.entities.notes.MLEVAL[key].XLEVRTNO)
                )
            })
            .sort((a, b) => state.entities.notes.MLEVAL[a].XLEVNO - state.entities.notes.MLEVAL[b].XLEVNO)
            .map(key => state.entities.notes.MLEVAL[key]),
        isSpeech
    };
}

const connectedAlEval = connect(mapStateToProps, mapDispatchToProps)(AlEval);
export { connectedAlEval as AlEval };

